export const EUROPEAN_COUNTRIES = [
	{ label: 'countries.AL', value: 'AL' },
	{ label: 'countries.AD', value: 'AD' },
	{ label: 'countries.AT', value: 'AT' },
	{ label: 'countries.BY', value: 'BY' },
	{ label: 'countries.BE', value: 'BE' },
	{ label: 'countries.BA', value: 'BA' },
	{ label: 'countries.BG', value: 'BG' },
	{ label: 'countries.HR', value: 'HR' },
	{ label: 'countries.CY', value: 'CY' },
	{ label: 'countries.CZ', value: 'CZ' },
	{ label: 'countries.DK', value: 'DK' },
	{ label: 'countries.EE', value: 'EE' },
	{ label: 'countries.FI', value: 'FI' },
	{ label: 'countries.FR', value: 'FR' },
	{ label: 'countries.DE', value: 'DE' },
	{ label: 'countries.GR', value: 'GR' },
	{ label: 'countries.HU', value: 'HU' },
	{ label: 'countries.IS', value: 'IS' },
	{ label: 'countries.IE', value: 'IE' },
	{ label: 'countries.IT', value: 'IT' },
	{ label: 'countries.XK', value: 'XK' },
	{ label: 'countries.LV', value: 'LV' },
	{ label: 'countries.LI', value: 'LI' },
	{ label: 'countries.LT', value: 'LT' },
	{ label: 'countries.LU', value: 'LU' },
	{ label: 'countries.MT', value: 'MT' },
	{ label: 'countries.MD', value: 'MD' },
	{ label: 'countries.MC', value: 'MC' },
	{ label: 'countries.ME', value: 'ME' },
	{ label: 'countries.NL', value: 'NL' },
	{ label: 'countries.MK', value: 'MK' },
	{ label: 'countries.NO', value: 'NO' },
	{ label: 'countries.PL', value: 'PL' },
	{ label: 'countries.PT', value: 'PT' },
	{ label: 'countries.RO', value: 'RO' },
	{ label: 'countries.RU', value: 'RU' },
	{ label: 'countries.SM', value: 'SM' },
	{ label: 'countries.RS', value: 'RS' },
	{ label: 'countries.SK', value: 'SK' },
	{ label: 'countries.SI', value: 'SI' },
	{ label: 'countries.ES', value: 'ES' },
	{ label: 'countries.SE', value: 'SE' },
	{ label: 'countries.CH', value: 'CH' },
	{ label: 'countries.UA', value: 'UA' },
	{ label: 'countries.GB', value: 'GB' },
	{ label: 'countries.VA', value: 'VA' },
];
